import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { UserFilters } from '../types';

const defaults: UserFilters = {
  s: undefined,
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  roleId: undefined,
  status: undefined,
};

const numberFields: (keyof UserFilters)[] = ['limit', 'page', 'roleId'];

export function useUserFilters(initialFilters: Partial<UserFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<UserFilters>({ defaults: mergedDefaults, numberFields });
}
